<template>
  <v-flex data-qa="amenddeposit-flex-k5fp4k">
    <Loader v-show="loaderEnabled"/>
    <v-flex class="pt-6 px-4" data-qa="amenddeposit-flex-zhich">
      <!-- Retain -->
      <!-- Step 2 Select MI & Pay Away Account Both -->
      <v-flex
        xs12 sm12 md12 lg12 xl12
        v-show="config.stepName === 'amendOptionBoth'"
       data-qa="amenddeposit-flex-6n98b9">
        <v-select
          v-model="selectedMIlabel"
          :label="$t('amendDeposit.amendMILabel')"
          :items="getConfiguredMI"
          :color="primaryColor"
          @change="getSelectedMaturityOption"
         data-qa="amenddeposit-select-26d1ah"></v-select>
        <v-flex v-if="isPartialCredit" class="mt-6 mb-4" data-qa="amenddeposit-flex-4upe93">
          <font class="body-1 font-weight-bold pb-2">
            {{ $t("amendDeposit.amtTransferToPayaway") }}
          </font>
        </v-flex>
        <v-flex v-if="isPartialCredit" class="mt-6 mb-4" data-qa="amenddeposit-flex-xewapo">
          <v-radio-group
            class="pa-0"
            v-model="selectedPartialCredit"
            @change="onPartialSelection()"
           data-qa="amenddeposit-radio-group-cq9rme">
          <v-row data-qa="amenddeposit-row-gnzjql">
            <v-col cols="4" data-qa="amenddeposit-col-x8dpfq">
              <v-row data-qa="amenddeposit-row-mdgmxz">
                <v-radio
                  v-if="isPartialCredit"
                  :color="secondaryColor"
                  class="font-weight-medium py-2"
                  value="partialAmount"
                 data-qa="amenddeposit-radio-m08k98n"></v-radio>
                <v-text-field data-qa="amenddeposit-text-field-czgwr7"
                  v-if="isPartialCredit"
                  :disabled="this.selectedPartialCredit === 'partialPercent'"
                  v-model="partialAmount"
                  :color="primaryColor"
                  filled
                  :label="$t('amendDeposit.amendAmountLabel')"
                  :prefix="$formatter.currency.getCurrencySymbol(
                  currencyFormat)"
                  @input="setPartial"
                  persistent-hint
                  type="number"
                  :hint="`${$t('amendDeposit.maxAmountLimit')} - ${$formatter.currency.format(
                  maturityAmount,
                  currencyFormat
                  )}`"
                  :rules="[rules.minValue, rules.maxValue]"
                  :class="[
                    'transferFunds--custom-textfield custom-amount' ,
                    'transferFunds--amountCurrencySymbolDefault'
                  ]"
                />
              </v-row>
            </v-col>
            <v-col cols="4" data-qa="amenddeposit-col-a93l7f">
              <v-row data-qa="amenddeposit-row-s62ccr">
                <v-radio
                  v-if="isPartialCredit"
                  :color="secondaryColor"
                  class="font-weight-medium py-2"
                  value="partialPercent"
                 data-qa="amenddeposit-radio-1x3h9p"></v-radio>
                <v-text-field data-qa="amenddeposit-text-field-ct6t15"
                  v-if="isPartialCredit"
                  :disabled="this.selectedPartialCredit === 'partialAmount'"
                  v-model="partialPercent"
                  filled
                  :color="primaryColor"
                  :label="$t('amendDeposit.amendPercentLabel')"
                  type="number"
                  @input="setPartial"
                  prefix="%"
                  persistent-hint
                  :rules="[rules.minPercent, rules.maxPercent]"
                  :class="[
                    'transferFunds--custom-textfield custom-amount' ,
                    'transferFunds--amountCurrencySymbolDefault'
                  ]"
                />
              </v-row>
            </v-col>
          </v-row>
          </v-radio-group>
        </v-flex>
        <v-flex v-if="(isFullCredit || isPartialCredit || isParentProductWithCommonEndDate) && !disableSubProductField" class="mt-6 mb-4" data-qa="amenddeposit-flex-4qra3">
          <font class="body-1 font-weight-bold pb-2">
            {{ $t("amendDeposit.preferredSubProduct") }}
          </font>
        </v-flex>
        <v-flex v-if="(isFullCredit || isPartialCredit || isParentProductWithCommonEndDate) && !disableSubProductField" data-qa="amenddeposit-flex-j4lv2s">
          <v-select
            v-model="selectedSubProduct"
            :label="$t('amendDeposit.amendSubProductLabel')"
            :items="listSubProducts"
            :color="primaryColor"
            @change="setSubProduct()"
           data-qa="amenddeposit-select-bknb0f"></v-select>
        </v-flex>
        <v-flex v-if="isPayAwayEnabled" class="mt-6 mb-4" data-qa="amenddeposit-flex-20llg">
          <font class="body-1 font-weight-bold pb-2">
            {{ $t("termDepositActions.breakDeposit.choosePayAwayAcLabel") }}
          </font>
          <br data-qa="amenddeposit-br-2yk38q" />
          <v-tabs
            v-model="selectedAccountType"
            @change="changeAccountType"
            :color="primaryColor"
            class="mt-4"
           data-qa="amenddeposit-tabs-4raoj">
            <v-tab class="text-capitalize font-weight-bold" data-qa="amenddeposit-tab-9pmhl">
              {{ $t("termDepositActions.listAC.internalButtonLabel") }}
            </v-tab>
            <v-tab v-if="isViewPayeePermittedForSme && !isTabDisabled" class="text-capitalize font-weight-bold" data-qa="amenddeposit-tab-061zsh">
              {{ $t("termDepositActions.listAC.externalButtonLabel") }}
            </v-tab>
          </v-tabs>
        </v-flex>
        <v-tabs-items v-model="selectedAccountType" data-qa="amenddeposit-tabs-items-knoxy">
          <v-tab-item data-qa="amenddeposit-tab-item-odamki">
            <ListAccountsSelect
              v-if="isPayAwayDisabled"
              v-model="selectedPayAwayObj"
              :label="$t('openDepositAcc.selectMaturityAccount')"
              :items="sameAccountsNOCRObj"
              return-object
              @input="setPayAwayAC"
            />
            <ListAccountsSelect
              v-if="isPayAwayEnabled && isAccountPIP"
              v-model="formData.selectedInterestPayAwayObj"
              :label="$t('openDepositAcc.selectInterestPayAwayAcc')"
              :items="sameAccountsNOCRObj"
              return-object
              @input="setPayAwayAC"
              class="mt-5"
            />
          </v-tab-item>
          <v-tab-item data-qa="amenddeposit-tab-item-g7rweo">
            <ListAccountsSelect
              v-if="isPayAwayDisabled"
              v-model="selectedPayAwayObj"
              :label="nominatedAccountsConfig.enableNominatedAccountFeatures ? $t('openDepositAcc.selectMaturityAccountNominated') : $t('openDepositAcc.selectMaturityAccount')"
              :items="otherAccounts"
              @input="setPayAwayAC"
              external return-object
            />
            <ListAccountsSelect
              v-if="isPayAwayEnabled && isAccountPIP"
              v-model="formData.selectedInterestPayAwayObj"
              :label="nominatedAccountsConfig.enableNominatedAccountFeatures ? $t('openDepositAcc.selectInterestPayAwayAccNominated') : $t('openDepositAcc.selectInterestPayAwayAcc')"
              :items="otherAccounts"
              external return-object
              @input="setPayAwayAC"
              class="mt-5"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-flex>
    <!-- OTP Component -->
    <Modal
      v-if="otpConfig.enabled"
      :config="otpConfig"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="amenddeposit-span-acrvmj">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <!-- Amend Confirm Screen -->
    <ConfirmDeposit
      v-if="confirmFormData.showConfimModal"
      :config="confirmFormData"
    />
  </v-flex>
</template>

<script>
import '@/styles/pages/accounts/deposits/amendDeposit.scss'
import commonService from '@/service/commonService.js'
import '@/styles/pages/transferFunds.scss'
import event from '@/util/event'
import _ from 'lodash'
import maturityInstructions from '@/../mocks/maturityInstructions.json'
import preload from '@/util/preload'
import Loader from '../../../components/common/Loader.vue'
import ListAccountsSelect from './ListAccountsSelect.vue'
import { getAccountTypeLabel } from '../../../util/accountUtil'
import smeRolesMixin from '@/core/mixins/smeRolesMixin.js'

export default {
  name: 'AmendDeposit',
  props: {
    config: {
      type: Object
    }
  },
  components: {
    Loader,
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput: () => import('@/components/common/OtpInput.vue'),
    ConfirmDeposit: () => import('@/views/accounts/termDepositActions/ConfirmDeposit.vue'),
    ListAccountsSelect
  },
  mixins: [ smeRolesMixin ],
  data () {
    return {
      loaderEnabled: false,
      confirmFormData: {
        showConfimModal: false
      },
      formData: {
        externalAccounts: [],
        internalAccounts: [],
        accountNumber: '',
        selectedInternalPayAwayAccount: '',
        selectedExternalPayAwayAccount: '',
        selectedExternalAccBeneficiaryId: '',
        selectedMaturityOption: '',
        maturityInstructions,
        payAwayFundingAccount: '',
        internalPayawayAccountBalance: '',
        accountType: '',
        selectedAmendOption: '',
        tdDetailsExternalPayAwayAcc: '',
        tdDetailsInterestExternalPayAwayAcc: '',
        selectedInterestPayAwayObj: ''
      },
      tdDetails: {},
      termDepositDetails: {},
      beneficiaries: [],
      beneficiaryDetails: null,
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredWithNoErrRule: (v) => Boolean(v) || '',
        requiredAmountRule: (v) => (Boolean(v) && !!v.length) || this.$t('errors.common.amountRequired'),
        minValue: (v) => v > 0 || this.$t('amendDeposit.minRolloverAmountVal'),
        maxValue: (v) => v < this.maturityAmount || this.$t('amendDeposit.maxRolloverAmountVal'),
        maxPercent: (v) => v < 100 || this.$t('amendDeposit.maxRolloverPercent'),
        minPercent: (v) => v > 0 || this.$t('amendDeposit.minRolloverPercent')
      },
      enableOTP: this.$appSettings.defaultConfigurations.enableOTPForAmendTD,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      otpConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      currencyFormat: '',
      interestPayout: '',
      selectedMIlabel: '',
      stepName: '',
      sameAccounts: [],
      otherAccounts: [],
      sameAccountsNOCR: [],
      sameAccountsNOCRObj: [],
      listSubProducts: [],
      listSubProductsId: [],
      selectedSubProductId: '',
      selectedAccountType: 0,
      selectedPayAwayObj: null,
      selectedSubProduct: '',
      setMaturityOption: '',
      isPartialCredit: false,
      partialAmount: '',
      partialPercent: '',
      selectedPartialCredit: 'partialAmount',
      maturityAmount: '',
      nominatedAccountsConfig: this.$appSettings.defaultConfigurations.nominatedAccounts,
      removeNoInstruction: this.$appSettings.defaultConfigurations.maturityInstruction.deposits.removeNoInstruction,
      isEndDateCommonForAllAccounts: false,
      isTabDisabled: false,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      isViewPayeePermittedForSme: false,
      permissions: []
    }
  },
  async created () {
    const self = this
    if (this.$route.params.product !== undefined) {
      this.productDetails = this.$route.params.product
      this.formData.accountNumber = this.productDetails.accountId
    }
    this.isTabDisabled = this.productDetails?.jointHolderNames?.some(holder =>
      holder.jointholderId === JSON.parse(sessionStorage.getItem('username'))
    )
    // Fetch Permissions for SME Users
    this.permissions = this.$store.getters['profileStore/profileData']?.permissions
    this.isViewPayeePermittedForSme = this.isSmeRoleBasedAccessEnabled() ? this.permissions?.includes('VIEW_PAYEES') : true
    this.isEndDateCommonForAllAccounts = this.$route.params?.currentProductSummary?.isEndDateCommonForAllAccounts
    await this.getFixedDepositDetails(this.formData.accountNumber)
    event.$on('listAccounts', args => {
      self.formData.accountType =
        args.selectedAccountType
      if (args.selectedAccountType === 'Internal') {
        self.formData.selectedExternalPayAwayAccount = ''
        self.formData.selectedExternalAccBeneficiaryId = ''
        self.formData.selectedInternalPayAwayAccount = args.selectedInternalPayAwayAccount
      }
      if (args.selectedAccountType === 'External') {
        self.formData.selectedInternalPayAwayAccount = ''
        self.formData.selectedExternalPayAwayAccount = args.selectedExternalPayAwayAccount.accountIdentification
        self.formData.selectedExternalAccBeneficiaryId = args.selectedExternalPayAwayAccount.beneficiaryId
      }
      if (self.formData?.selectedExternalPayAwayAccount?.length || self.formData?.selectedInternalPayAwayAccount?.length) {
        event.$emit('disableNextBtn', false)
      } else {
        event.$emit('disableNextBtn', true)
      }
    })
    event.$on('onFormConfirm', args => {
      this.stepName = args.stepName
      this.onFormConfirm(args)
    })
    event.$on('verifyOTP', args => {
      this.otpConfig.enabled = true
    })
    event.$on('IS_OTP_VALID', (val) => {
      if (val && this.otpConfig.enabled) {
        this.otpConfig.enabled = false
        this.amendTermDeposit()
      } else {
        this.amendTermDeposit()
      }
    })
  },
  computed: {
    getConfiguredMI () {
      let temp = []
      if (this.formData.maturityInstructions && this.formData.maturityInstructions.length) {
        temp = this.formData.maturityInstructions.map(item => {
          return item.value
        })
        return temp
      }
      return temp
    },
    isMIrestricted () {
      const Mi = ['NO-INSTRUCTION', 'NOINSTRUCTION', 'MANUALREDEMPTION', 'NOT-APPLICABLE', 'NOTAPPLICABLE']
      return Mi.includes(this.formData.selectedMaturityOption)
    },
    isPayAwayDisabled () {
      return this.formData.selectedMaturityOption ? !this.isMIrestricted : false
    },
    isPayAwayEnabled () {
      if (this.tdDetails && this.formData.selectedMaturityOption) {
        if (this.tdDetails.interestPayout === 'PIP') return true
        else return !this.isMIrestricted
      }
      return false
    },
    isParentProductWithCommonEndDate () { return this.isEndDateCommonForAllAccounts && ['PAYAWAY-PRINCIPAL', 'PAYAWAY-INTEREST'].includes(this.formData.selectedMaturityOption) },
    isFullCredit () { return this.formData.selectedMaturityOption === 'CAPITALISE' },
    isAccountPIP () { return this.tdDetails?.interestPayout === 'PIP' },
    selectedPayAwayAcc () { return this.selectedPayAwayObj?.text ?? '' },
    formDataSelectedInterestPayAwayAcc () { return this.formData.selectedInterestPayAwayObj?.text ?? '' },
    disableSubProductField () { return this.isAccountPIP && ['PAYAWAY-PRINCIPAL'].includes(this.formData.selectedMaturityOption) }
  },
  methods: {
    setPartial () {
      if (((this.partialAmount > 0 && this.partialAmount < this.maturityAmount) || (this.partialPercent > 0 && this.partialPercent < 100)) &&
      this.selectedSubProduct &&
      (this.formDataSelectedInterestPayAwayAcc || this.selectedPayAwayAcc)) {
        event.$emit('disableNextBtn', false)
      } else event.$emit('disableNextBtn', true)
    },
    onOtpModalClose () {
      this.otpConfig.enabled = false
    },
    // Handle stepper btn's
    onFormConfirm (props) {
      switch (props.stepName) {
        case 'amendOptionBoth':
          if (this.formData.selectedMaturityOption) {
            const Mi = ['CAPITALISE', 'CAPTALISE', 'PAYAWAY-PARTIAL', 'PAYAWAYPARTIAL', 'NO-INSTRUCTION', 'NOINSTRUCTION', 'MANUALREDEMPTION', 'NOT-APPLICABLE', 'NOTAPPLICABLE']
            if (Mi.includes(this.formData.selectedMaturityOption)) {
              event.$emit('disableNextBtn', false)
            } else {
              if (this.formData?.selectedExternalPayAwayAccount?.length || this.formData?.selectedInternalPayAwayAccount?.length) {
                event.$emit('disableNextBtn', false)
              } else {
                event.$emit('disableNextBtn', true)
              }
            }
          } else {
            event.$emit('disableNextBtn', true)
          }
          break
        default:
      }
    },
    isPristine () {
      event.$emit('amendDepositDataSanity', true)
    },
    getFormData (respData) {
      this.confirmFormData = { showConfimModal: false }
      if (respData) {
        this.confirmFormData.action = 'amend'
        this.confirmFormData.showConfimModal = true
        this.confirmFormData.tdDetails = this.tdDetails
        this.confirmFormData.amendedOption = 'amendBothOption'
      }
    },
    async getAccountsWithBalance () {
      this.loaderEnabled = true
      const response = await preload.getAllCASAWithBalance(JSON.parse(sessionStorage.getItem('username')))
      if (response && !response.causes) {
        let accounts = await this.getFilteredAccounts(response)
        this.fetchSameAccounts(accounts)
      }
      setTimeout(() => {
        this.loaderEnabled = false
      }, 500)
    },
    async getBeneficiaries () {
      const self = this
      const resp = await commonService.getBeneficiaries(
        JSON.parse(sessionStorage.getItem('username'))
      )
      if (resp && !resp.causes) {
        this.beneficiaries = resp.items
        for (const i in resp.items) {
          if (resp.items[i].accountIdentification === self.tdDetails.payCapitalToAccount) {
            self.formData.tdDetailsExternalPayAwayAcc = resp.items[i].beneficiaryId
          }
          if (resp.items[i].accountIdentification === self.tdDetails.payInterestToAccount) {
            self.formData.tdDetailsInterestExternalPayAwayAcc = resp.items[i].beneficiaryId
          }
        }
        await this.fetchOtherAccounts(this.beneficiaries)
      }
    },
    getPayAwayAcc (type) {
      switch (type) {
        case 'External' :
          if (this.selectedPayAwayAcc) {
            const beneficiaryDetails = _.find(this.beneficiaries, o => {
              return o.accountIdentification === this.selectedPayAwayAcc.split('-')[0].trim()
            })
            return beneficiaryDetails ? beneficiaryDetails.beneficiaryId : null
          }
          return null
        case 'Internal' :
          if (this.selectedPayAwayAcc) return this.selectedPayAwayAcc.split('-')[1].trim()
          return null
        default : return null
      }
    },
    getInterestPayAwayAcc (type) {
      switch (type) {
        case 'External' :
          if (this.isAccountPIP && this.formDataSelectedInterestPayAwayAcc) {
            const beneficiaryDetails = _.find(this.beneficiaries, o => {
              return o.accountIdentification === this.formDataSelectedInterestPayAwayAcc.split('-')[0].trim()
            })
            return beneficiaryDetails ? beneficiaryDetails.beneficiaryId : null
          }
          return null
        case 'Internal' :
          if (this.formDataSelectedInterestPayAwayAcc) return this.formDataSelectedInterestPayAwayAcc.split('-')[1].trim()
          return null
        default : break
      }
    },
    // MODIFY
    async amendTermDeposit () {
      const self = this
      self.loaderEnabled = true
      const selectedMI = self.setMaturityInstruction()
      const rolloverProductId = self.setSubProduct()
      const body = {
        maturityInstructions: selectedMI,
        rolloverProductId: self.selectedSubProduct ? rolloverProductId : null,
        rolloverAmount: self.partialAmount || null,
        rolloverPercentage: self.partialPercent ? self.partialPercent : (self.formData.selectedMaturityOption === 'CAPITALISE' ? 100 : null)
      }

      const isPayawayAccTypeInternal = self.selectedAccountType === 0
      const principalPayawayId = isPayawayAccTypeInternal ? self.getPayAwayAcc('Internal') : self.getPayAwayAcc('External')
      const interestPayawayId = isPayawayAccTypeInternal ? self.getInterestPayAwayAcc('Internal') : self.getInterestPayAwayAcc('External')

      body[isPayawayAccTypeInternal ? 'principalPayawayAccountId' : 'principalPayawayBeneficiaryId'] = selectedMI === 'PAYAWAY-INTEREST' ? '' : principalPayawayId || ''
      body[isPayawayAccTypeInternal ? 'interestPayawayAccountId' : 'interestPayawayBeneficiaryId'] = ['PAYAWAY-PRINCIPAL', 'CAPITALISE'].includes(selectedMI) && !self.isAccountPIP ? ''
        : self.isAccountPIP ? interestPayawayId
          : principalPayawayId || ''

      const response = await commonService.amendTermDepositAccount(self.productDetails.accountId, body)

      if (response && !response.causes) {
        response.accountId && self.getFormData(response)
      }
      self.loaderEnabled = false
    },
    setMaturityInstruction () {
      if (this.formData.selectedMaturityOption === 'PAYAWAY-PARTIAL') {
        return 'CAPITALISE'
      } else return this.formData.selectedMaturityOption
    },
    configureMaturityInstruction (type) {
      const a = JSON.stringify(this.formData.maturityInstructions)
      const b = JSON.parse(a)
      // Remove the 'NO-INSTRUCTION', 'NOT-APPLICABLE' if  appConfig removeNoInstruction is set
      if (this.removeNoInstruction) {
        _.remove(b, o => {
          return o.key === 'NOT-APPLICABLE' || o.key === 'NO-INSTRUCTION'
        })
      }
      this.formData.maturityInstructions = b
      switch (type) {
        case 'CUMULATIVE':
          _.remove(b, o => {
            return o.key === 'PAYAWAY-INTEREST' || o.key === 'PAYAWAY-PRINCIPAL'
          })
          this.formData.maturityInstructions = b
          break
        case 'PERIODIC':
        case 'Periodic':
        case 'PIP':
          _.remove(b, o => {
            return o.key === 'PAYAWAY-INTEREST' || o.key === 'PAYAWAY-BOTH'
          })
          this.formData.maturityInstructions = b
          break
        default : break
      }
      for (const item of this.formData.maturityInstructions) {
        item.value = type === 'PIP' && item.key === 'PAYAWAY-PRINCIPAL' ? this.$t('systemEnums.maturityInstructions.PIP-PAYAWAY-PRINCIPAL') : this.$t(`systemEnums.maturityInstructions.${item.key}`)
      }
    },
    async getFixedDepositDetails (accountNumber) {
      const self = this
      self.loaderEnabled = true
      const response = await commonService.getFixedDepositDetails(accountNumber)
      if (response) {
        self.tdDetails = response
        this.currencyFormat = response.maturityAmount.currency
        this.interestPayout = response.interestPayout
        this.maturityAmount = response.maturityAmount.value
        await this.getSubProductsList(this.currencyFormat, this.interestPayout)
        const MI = _.find(self.formData.maturityInstructions, o => { return o.enum === self.tdDetails.capitalizationMethod || o.key === self.tdDetails.capitalizationMethod })
        self.formData.selectedMaturityOption = self.tdDetails ? MI?.key : ''
        this.selectedMIlabel = this.$t(`systemEnums.maturityInstructions.${this.formData.selectedMaturityOption}`)
        this.configureMaturityInstruction(this.tdDetails.interestPayout)
        self.formData.accountType = self.tdDetails.allowPayAwaytoOtherBank ? 'External' : 'Internal'
        await self.getAccountsWithBalance()
        await self.getBeneficiaries()
        await this.setExistingMIValues()
      }
      self.loaderEnabled = false
    },
    getSelectedMaturityOption () {
      this.config.steps = [{
        name: 'amendOptionBoth'
      }]
      if (this.formData.maturityInstructions && this.formData.maturityInstructions.length) {
        const Mi = ['CAPITALISE', 'CAPTALISE', 'PAYAWAY-PARTIAL', 'PAYAWAYPARTIAL', 'NO-INSTRUCTION', 'NOINSTRUCTION', 'MANUALREDEMPTION', 'NOT-APPLICABLE', 'NOTAPPLICABLE']
        for (const item of this.formData.maturityInstructions) {
          if (item.value === this.selectedMIlabel) {
            this.formData.selectedMaturityOption = item.key
            break
          }
        }
        if (this.formData.selectedMaturityOption) {
          this.checkPartialCredit()
          if (Mi.includes(this.formData.selectedMaturityOption)) {
            this.clearAccounts()
            event.$emit('resetListAccounts', true)
            if (this.isAccountPIP) {
              event.$emit('disableNextBtn', true)
            } else event.$emit('disableNextBtn', false)
          } else {
            this.clearAccounts()
            if (
              (this.formData.selectedExternalPayAwayAccount &&
          this.formData.selectedExternalPayAwayAccount.length) ||
        (this.formData.selectedInternalPayAwayAccount &&
          this.formData.selectedInternalPayAwayAccount.length)) {
              event.$emit('disableNextBtn', false)
            } else {
              event.$emit('disableNextBtn', true)
            }
          }
        } else {
          event.$emit('disableNextBtn', true)
        }
      }
      this.setPayAwayAC()
      this.setSubProduct()
    },
    async getSubProductsList (currencyFormat, interestPayout) {
      const response = await commonService.getTermDepositProductsList({ currencyType: currencyFormat, interestPayOutType: interestPayout })
      if (response && response?.items?.length > 0) {
        const promises = response.items.map(i => commonService.getTDProductSummary(i.productId))
        const productSummaries = await Promise.allSettled(promises)
        // if the current product has common end date for all accounts, then filter only those products which have common end date for all accounts
        if (this.isEndDateCommonForAllAccounts) {
          response.items = productSummaries.filter((p) => p.status === 'fulfilled' && p.value.isEndDateCommonForAllAccounts && p.value.productCode !== (this.productDetails.productId || this.productDetails.productIdentifier)).map(i => i.value)
        } else {
          response.items = productSummaries.filter(p => p.status === 'fulfilled' && !p.value.isEndDateCommonForAllAccounts).map(i => i.value)
        }
        for (const i in response.items) {
          this.listSubProducts.push(`${response.items[i].productDescription}`)
          this.listSubProductsId.push(response.items[i].productId || response.items[i].productCode)
        }
      }
    },
    async getAccountDetails (accountId) {
      if (this.tdDetails.allowPayAwaytoOtherBank) {
        this.selectedAccountType = 1
        this.selectedPayAwayObj = this.otherAccounts.find(a => a.accountIdentification === accountId)
        this.formData.selectedInterestPayAwayObj = this.otherAccounts.find(a => a.accountIdentification === this.tdDetails?.interestPayoutAccount)
      } else {
        this.selectedAccountType = 0
        this.selectedPayAwayObj = this.sameAccountsNOCRObj.find(o => o.accountId === this.termDepositDetails.principalPayawayAccountId)
        this.formData.selectedInterestPayAwayObj = this.sameAccountsNOCRObj.find(o => o.accountId === this.termDepositDetails.interestPayawayAccountId)
      }
    },
    clearAccounts () {
      const self = this
      self.formData.selectedExternalPayAwayAccount = ''
      self.formData.selectedExternalAccBeneficiaryId = ''
      self.formData.selectedInternalPayAwayAccount = ''
      self.selectedSubProduct = ''
      self.partialAmount = ''
      self.partialPercent = ''
    },
    checkPartialCredit () {
      if (this.formData.selectedMaturityOption === 'PAYAWAY-PARTIAL') {
        this.isPartialCredit = true
      } else this.isPartialCredit = false
    },
    fetchSameAccounts (accounts) {
      for (const item of accounts) {
        const allowInactiveAccountTransactionalOperations = this.$appSettings.defaultConfigurations.allowInactiveAccountTransactionalOperations
        if (item.currency === this.tdDetails.isoCurrencyCode && item.postingsRestriction !== 'CREDIT' && item.accountStatus !== 'DORMANT') {
          if (allowInactiveAccountTransactionalOperations
            ? (!['TXSV'].includes(item.accountType) && ['ACTIVATED', 'INACTIVE'].includes(item.accountStatus))
            : !['TXNA', 'TXSV', 'TXFR', 'TXEA'].includes(item.accountType)) {
            if (item.postingsRestriction !== 'DEBIT') {
              if (['CACC', 'SVGS', 'NACC'].includes(item.accountType)) {
                this.sameAccounts.push(`${getAccountTypeLabel(item.accountType)} - ${item.accountId}`)
              }
            }
            if (item.postingsRestriction !== 'CREDIT') {
              if (['CACC', 'SVGS', 'NACC'].includes(item.accountType)) {
                const text = `${getAccountTypeLabel(item.accountType)} - ${item.accountId}`
                this.sameAccountsNOCR.push(text)
                this.sameAccountsNOCRObj.push({ ...item, text })
              }
            }
          }
        }
      }
    },
    fetchOtherAccounts (accounts) {
      this.otherAccounts = accounts
        .filter(a => a.currency === this.tdDetails.isoCurrencyCode &&
          (!this.nominatedAccountsConfig.enableNominatedAccountFeatures || a.ownAccount)
        )
        .map(a => ({ ...a, text: `${a.accountIdentification} - ${a.bankIdentifier}` }))
    },
    changeAccountType () {
      this.selectedPayAwayObj = null
      this.formData.selectedInterestPayAwayObj = null
      this.setPayAwayAC()
    },
    onPartialSelection () {
      if (this.selectedPartialCredit === 'partialAmount') {
        this.isPercentDisabled = true
        this.partialPercent = ''
        event.$emit('disableNextBtn', true)
      } else {
        this.isAmountDisabled = true
        this.partialAmount = ''
        event.$emit('disableNextBtn', true)
      }
    },
    async setExistingMIValues () {
      const response = await commonService.getTermDepositAccDetails(this.formData.accountNumber)
      this.termDepositDetails = response
      if (['NO-INSTRUCTION', 'NOT-APPLICABLE'].includes(this.formData.selectedMaturityOption)) {
        if (this.isAccountPIP && (response.interestPayawayAccountId || response.interestPayawayBeneficiaryId)) {
          await this.getAccountDetails(response.interestPayawayAccountId || response.interestPayawayBeneficiaryId)
        }
        event.$emit('disableNextBtn', false)
      }
      if ((response.principalPayawayAccountId) || (response.principalPayawayBeneficiaryId && response.interestPayawayBeneficiaryId)) {
        await this.getAccountDetails(response.principalPayawayAccountId || this.tdDetails.payCapitalToAccount)

        if (response.rolloverProductId) {
          this.selectedSubProduct = this.listSubProducts[this.listSubProductsId.indexOf(response.rolloverProductId)]
          if (response.rolloverAmount < response.maturityAmount.value || response.rolloverPercentage < 100) {
            this.isPartialCredit = true
            this.isFullCredit = false
            this.selectedMIlabel = this.$t('systemEnums.maturityInstructions.PAYAWAY-PARTIAL')
            this.formData.selectedMaturityOption = 'PAYAWAY-PARTIAL'
            this.partialAmount = response.rolloverAmount || ''
            this.partialPercent = response.rolloverPercentage || ''
            if (this.partialPercent) {
              this.selectedPartialCredit = 'partialPercent'
            }
            if (this.partialAmount) {
              this.selectedPartialCredit = 'partialAmount'
            }
          } else {
            event.$emit('disableNextBtn', false)
            this.isPartialCredit = false
            this.isFullCredit = true
          }
        }
        event.$emit('disableNextBtn', false)
      }
    },
    setSubProduct () {
      if ((this.formData.selectedMaturityOption === 'CAPITALISE') || (this.isEndDateCommonForAllAccounts && ['PAYAWAY-PRINCIPAL', 'PAYAWAY-INTEREST'].includes(this.formData.selectedMaturityOption))) {
        if (this.selectedSubProduct && ((this.formData.selectedInternalPayAwayAccount || this.selectedPayAwayAcc) || this.formData.selectedExternalPayAwayAccount)) {
          const index = this.listSubProducts.indexOf(this.selectedSubProduct)
          this.selectedSubProductId = this.listSubProductsId[index]
          event.$emit('disableNextBtn', false)
          return this.selectedSubProductId
        } else {
          event.$emit('disableNextBtn', true)
          if (this.formDataSelectedInterestPayAwayAcc && this.selectedPayAwayAcc && this.isAccountPIP && ['PAYAWAY-PRINCIPAL'].includes(this.formData.selectedMaturityOption)) {
            event.$emit('disableNextBtn', false)
          } else event.$emit('disableNextBtn', true)
        }
      }
      if (this.formData.selectedMaturityOption === 'PAYAWAY-PARTIAL') {
        if ((this.partialAmount > 0 || this.partialPercent > 0) &&
          this.selectedSubProduct &&
          ((this.formData.selectedInternalPayAwayAccount || this.selectedPayAwayAcc) || this.formData.selectedExternalPayAwayAccount)) {
          const index = this.listSubProducts.indexOf(this.selectedSubProduct)
          this.selectedSubProductId = this.listSubProductsId[index]
          event.$emit('disableNextBtn', false)
          return this.selectedSubProductId
        } else {
          event.$emit('disableNextBtn', true)
        }
      }
      if (['NO-INSTRUCTION', 'NOT-APPLICABLE'].includes(this.formData.selectedMaturityOption) && !this.isAccountPIP) {
        event.$emit('disableNextBtn', false)
      }
    },
    setPayAwayAC () {
      if (this.isMIrestricted) {
        if (this.isAccountPIP) {
          if (this.formDataSelectedInterestPayAwayAcc) {
            if (this.formData.selectedMaturityOption === 'PAYAWAY-PARTIAL') {
              if (((this.partialAmount > 0 && this.partialAmount < this.maturityAmount) || (this.partialPercent > 0 && this.partialPercent < 100)) && this.selectedSubProduct) {
                event.$emit('disableNextBtn', false)
              } else event.$emit('disableNextBtn', true)
            }
            if (this.formData.selectedMaturityOption === 'CAPITALISE') {
              if (this.selectedSubProduct) {
                event.$emit('disableNextBtn', false)
              } else event.$emit('disableNextBtn', true)
            }
            event.$emit('disableNextBtn', false)
          } else event.$emit('disableNextBtn', true)
        } else event.$emit('disableNextBtn', false)
      } else {
        if (this.isAccountPIP) {
          switch (this.formData.selectedMaturityOption) {
            case 'PAYAWAY-PARTIAL':
              if (((this.partialAmount > 0 && this.partialAmount < this.maturityAmount) || (this.partialPercent > 0 & this.partialPercent < 100)) &&
              this.selectedSubProduct && this.selectedPayAwayAcc && this.formDataSelectedInterestPayAwayAcc) {
                event.$emit('disableNextBtn', false)
              } else event.$emit('disableNextBtn', true)
              break
            case 'CAPITALISE':
              if (this.selectedPayAwayAcc && this.formDataSelectedInterestPayAwayAcc && this.selectedSubProduct) {
                event.$emit('disableNextBtn', false)
              } else event.$emit('disableNextBtn', true)
              break
            default:
              if (this.selectedPayAwayAcc && this.formDataSelectedInterestPayAwayAcc) {
                event.$emit('disableNextBtn', false)
              } else event.$emit('disableNextBtn', true)
              break
          }
        } else {
          if (this.selectedPayAwayAcc) {
            switch (this.formData.selectedMaturityOption) {
              case 'PAYAWAY-PARTIAL':
                if (((this.partialAmount > 0 && this.partialAmount < this.maturityAmount) ||
                (this.partialPercent > 0 && this.partialPercent < 100)) && this.selectedSubProduct) {
                  event.$emit('disableNextBtn', false)
                } else event.$emit('disableNextBtn', true)
                break
              case 'CAPITALISE':
                if (this.selectedSubProduct) {
                  event.$emit('disableNextBtn', false)
                } else event.$emit('disableNextBtn', true)
                break
              default:
                event.$emit('disableNextBtn', false)
                break
            }
          } else event.$emit('disableNextBtn', true)
        }
      }
    }
  },
  beforeDestroy () {
    event.$off('listAccounts')
    event.$off('onFormConfirm')
    event.$off('verifyOTP')
    event.$off('IS_OTP_VALID')
  }
}
</script>
